<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="medium">
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item label="包装编号" prop="packageNo">
            <el-input
              clearable
              style="font-size:20px;"
              v-model="formData.packageNo"
              placeholder="请输入包装编号"
              @input="clear()"
              @keyup.enter.native="onSubmit()"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="件数" prop="packageQty">
            <el-input
              clearable
              v-model="formData.packageQty"
              @change="updateBoxQty()"
              placeholder="请输入件数"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="箱数" prop="boxQty">
            <el-input
              clearable
              v-model="formData.boxQty"
              placeholder="请输入箱数"
              :disabled="this.type === 'A'"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="长（米）" prop="packageLength">
            <el-input readonly v-model="formData.packageLength"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="宽（米）" prop="packageWidth">
            <el-input readonly v-model="formData.packageWidth"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="高（米）" prop="packageHeight">
            <el-input
              clearable
              :readonly="this.type === 'A'"
              @change="changePackageHeight()"
              v-model="formData.packageHeight"
              placeholder="请输入高"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="包装类型" prop="packageType">
            <el-input readonly v-model="formData.packageTypeName"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="体积（立方）" prop="packageVolume">
            <el-input readonly v-model="formData.packageVolume"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="总体积" prop="subVolume">
            <el-input readonly v-model="subVolume"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="总体积重" prop="subVolumeWeight">
            <el-input readonly v-model="subVolumeWeight"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="称重重量" prop="subWeight">
            <el-input-number
              v-model="formData.subWeight"
              :controls="false"
              :precision="4"
              size="medium"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="计费重量" prop="subPriceWeight">
            <el-input readonly v-model="subPriceWeight"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import { multiply, round, multiplyRound } from '@/libs/util.number.js'
export default {
  components: {},
  props: {
    param: { type: Object, default: () => {} },
    type: { type: String, default: '' },
    transportMode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      useTransWeightRatio: '',
      rules: {
        packageTypeName: [
          {
            required: true,
            message: '请输入包装类型',
            trigger: 'blur',
          },
        ],
        packageNo: [
          {
            required: true,
            message: '请输入包装编号',
            trigger: 'blur',
          },
        ],
        packageLength: [
          {
            required: true,
            message: '请输入长',
            trigger: 'blur',
          },
        ],
        packageWidth: [
          {
            required: true,
            message: '请输入宽',
            trigger: 'blur',
          },
        ],

        packageHeight: [
          {
            required: true,
            pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
            message: '高应为不小于0的数字',
            trigger: 'blur',
          },
        ],

        packageVolume: [
          {
            required: true,
            message: '请输入体积',
            trigger: 'blur',
          },
          {
            type: 'number',
            min: 0.0001,
            message: '体积应大于0',
            trigger: 'blur',
          },
        ],
        packageQty: [
          { required: true, message: '请输入件数' },
          {
            pattern: /^[1-9]\d*$/,
            message: '件数应是正整数',
            trigger: 'blur',
          },
        ],
        boxQty: [
          { required: true, message: '请输入箱数' },
          {
            pattern: /^[1-9]\d*$/,
            message: '箱数应是正整数',
            trigger: 'blur',
          },
        ],
        subWeight: [
          { required: true, message: '请输入称重重量', trigger: 'blur' },
          {
            type: 'number',
            min: 0.0001,
            message: '称重重量应大于0',
            trigger: 'blur',
          },
        ],
      },
      formData: {
        packageType: '',
        packageTypeName: '',
        packageNo: '',
        packageLength: '',
        packageWidth: '',
        packageHeight: '',
        packageVolume: '',
        packageQty: '',
        subVolume: '',
        subVolumeWeight: '',
        subWeight: '',
        subPriceWeight: '',
        boxQty: '',
      },
    }
  },
  mounted() {
    this.setProperty()
  },
  watch: {
    packageVolume: {
      handler(val) {
        this.formData = {
          ...this.formData,
          packageVolume: val,
        }
      },
      immediate: true,
    },
  },
  computed: {
    packageVolume() {
      const { packageLength, packageWidth, packageHeight } = this.formData

      //判断字符串是否为数字
      const numReg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
      if (!numReg.test(packageHeight)) return 0
      return multiplyRound(multiply(packageHeight, packageLength), packageWidth)
    },
    subVolume() {
      const { packageQty } = this.formData

      //判断正整数
      const numReg = /^[1-9]\d*$/
      if (!numReg.test(packageQty)) return 0

      return multiplyRound(this.packageVolume, packageQty)
    },

    subVolumeWeight() {
      return multiplyRound(this.useTransWeightRatio, this.subVolume, 2)
    },

    subPriceWeight() {
      const { subWeight } = this.formData
      if (this.transportMode === '2') return subWeight
      return this.subVolumeWeight > subWeight ? this.subVolumeWeight : subWeight
    },
  },
  methods: {
    setProperty() {
      if (this.param.packageNo) {
        this.formData = { ...this.param }
      }
      if (this.type === 'A') {
        this.formData.packageTypeName = '散箱'
      }
      if (this.type === 'B') {
        this.formData.packageTypeName = '托盘'
      }
      this.formData.packageType = this.type
      this.$api
        .getSysParameterByIdApi({ paramID: 'heavyBubbleRatio' })
        .then((res) => {
          this.useTransWeightRatio = res.body.paramValue
        })
    },

    onSubmit() {
      if (this.formData.packageNo) {
        this.$api
          .bizWaybillWeightGoodDetailApi({
            packageNo: this.formData.packageNo,
          })
          .then((res) => {
            this.formData.packageLength = res.body.packageLength
            this.formData.packageWidth = res.body.packageWidth
            if (this.type === 'A') {
              this.formData.packageHeight = res.body.packageHeight
            }
            this.formData.packageVolume = res.body.packageVolume
          })
      }
    },
    async addBoxData() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.formData.packageVolume = this.packageVolume
      this.formData.subVolume = this.subVolume
      this.formData.subVolumeWeight = this.subVolumeWeight
      this.formData.subPriceWeight = this.subPriceWeight
      return this.formData
    },
    clear() {
      this.formData.packageLength = ''
      this.formData.packageWidth = ''
      this.formData.packageHeight = ''
      this.formData.packageVolume = ''
    },
    updateBoxQty() {
      const { packageQty } = this.formData
      //判断正整数
      const numReg = /^[1-9]\d*$/
      if (!numReg.test(packageQty)) return

      if (this.type === 'A') {
        this.formData.boxQty = packageQty
      }
    },
    changePackageHeight() {
      const { packageHeight } = this.formData
      const numReg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
      if (!numReg.test(packageHeight)) return

      this.formData.packageHeight = round(packageHeight, 4)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
</style>
